
    <div class="g-counter">{{(state.currIndex + 1) + '/' + state.items.length}}</div>
  